module.exports = __webpack_public_path__ + "static/cover.77bc9ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards_ceremony/cover.jpg
// module id = 553
// module chunks = 138584234813021